var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.733 11.9974L23.8845 12.8544L12.0051 0.85696L12.8536 2.87569e-06L24.733 11.9974Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8845 11.1456L24.733 12.0026L12.8537 24L12.0051 23.143L23.8845 11.1456Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.733086 11.5133L23.5331 11.5133L23.5331 12.7252L0.733086 12.7252L0.733086 11.5133Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjQuNzMzIDExLjk5NzRMMjMuODg0NSAxMi44NTQ0TDEyLjAwNTEgMC44NTY5NkwxMi44NTM2IDIuODc1NjllLTA2TDI0LjczMyAxMS45OTc0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+PHBhdGggZD0iTTIzLjg4NDUgMTEuMTQ1NkwyNC43MzMgMTIuMDAyNkwxMi44NTM3IDI0TDEyLjAwNTEgMjMuMTQzTDIzLjg4NDUgMTEuMTQ1NloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC43MzMwODYgMTEuNTEzM0wyMy41MzMxIDExLjUxMzNMMjMuNTMzMSAxMi43MjUyTDAuNzMzMDg2IDEyLjcyNTJMMC43MzMwODYgMTEuNTEzM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPg==";
export { ForwardRef as ReactComponent };